<template>
  <div class="memberDetails">
    <v-form ref="form" v-model="isFormValid" :style="{ maxWidth: formMaxWidth + 'px' }">
      <TabForm
        :formElements="formElements"
        :readOnly="!isEditMode"
        @max_column="calculateMaxFormWidth"
      ></TabForm>
    </v-form>
    <v-footer
      v-if="showFormButtons"
      padless
      fixed
      outlined
      class="footerBtnContainer"
      elevation="3"
    >
      <div class="btnContainer">
        <v-btn
          outlined
          v-if="!isEditMode && selectedMemberId"
          @click="onDelete"
          color="error"
          class="mr-4"
        >
          Delete member
        </v-btn>

        <v-btn
          v-if="isEditMode && !isNewMemberForm && canReverseStatus"
          color="primary"
          outlined
          class="mr-4"
          @click="onReverseStatus"
        >
          Reverse Status
        </v-btn>
        <v-btn
          v-if="isEditMode && !isNewMemberForm && canSetExitStatus"
          color="primary"
          outlined
          class="mr-4"
          @click="onSetExitStatus"
        >
          Set Exit Status
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn outlined v-if="isEditMode" @click="onCancel" color="primary" class="ml-4">
          Cancel
        </v-btn>
        <v-btn
          v-if="isEditMode"
          @click="onSave"
          depressed
          :disabled="!isFormValid"
          color="primary"
          class="ml-4"
        >
          Save
        </v-btn>
        <v-btn
          outlined
          v-if="!isEditMode && selectedMemberId"
          @click="onEdit"
          color="primary"
          class="ml-4"
        >
          Edit
        </v-btn>
      </div>
    </v-footer>
    <v-dialog v-model="setExit" width="500">
      <v-card>
        <v-card-title> Set Exit Status </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field label="Current Status" readonly v-model="currentStatus"></v-text-field>
            <DatePicker label="Exit Date" v-model="exitDate"></DatePicker>
            <v-select
              v-model="newStatus"
              :items="statusList"
              label="New Status"
              item-text="Text"
              item-value="Id"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="setExit = false"> Cancel </v-btn>
          <v-btn color="primary" depressed @click.native="ok"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialog ref="confirmationDialog" v-model="dialog"></Dialog>
  </div>
</template>

<script>
import TabForm from '@/components/TabForm.vue';
import Dialog from '@/components/layout/Dialog.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';
import Utils from '@/utils.js';

export default {
  name: 'MemberDetails',
  components: {
    TabForm,
    Dialog,
    DatePicker,
  },
  data() {
    return {
      formElements: [],
      memberData: null,
      userData: null,
      isEditMode: false,
      isFormValid: false,
      isNewMemberForm: false,
      formMaxWidth: 500,
      dialog: false,
      setExit: false,
      statusList: [],
      newStatus: null,
      currentStatus: 10,
      exitDate: null,
      resolve: null,
      reject: null,
      stateNoCheck: '',
      canReverseStatus: false,
      canSetExitStatus: false,
    };
  },
  mounted: function () {
    if (!this.selectedMemberId) {
      this.isEditMode = true;
      this.isNewMemberForm = true;
      //this.$store.commit('setNotificationMessage', {
      //  type: 'info',
      //  text: 'Please, select member',
      //});
      //this.$router.push({ path: '/' });
      //} else {
    }
    this.getMemberForm();
    this.getStatusPermissions();
  },
  methods: {
    ok() {
      this.resolve(true);
    },

    async setExitStatusDialog() {
      this.setExit = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    async onSetExitStatus() {
      if (!this.canSetExitStatus) return;

      try {
        await this.setExitStatusDialog();
        var data = {
          MembershipId: this.selectedMemberId,
          ExitDate: this.exitDate,
          ExitStatus: this.newStatus,
        };
        await this.$api.post('/member/setexitstatus', data);

        this.setExit = false;
        this.getMemberData();
      } catch (err) {
        console.log(err);
      }
    },
    async onReverseStatus() {
      if (!this.canReverseStatus) return;

      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to reverse the current status'
        );
        await this.$api.post('/member/reversestatus?membershipId=' + this.selectedMemberId);

        this.getMemberData();
      } catch (err) {
        console.log(err);
      }
    },
    async getStatusPermissions() {
      this.canReverseStatus = false;
      this.canSetExitStatus = false;

      try {
        const [reverseStatusPermission, setExitStatusPermission] = await Promise.all([
          this.$api.get('/user/GetTaskPermission', {
            params: { planId: this.currentPlanId, taskName: 'Reverse Status' },
          }),
          this.$api.get('/user/GetTaskPermission', {
            params: { planId: this.currentPlanId, taskName: 'Set Exit Status' },
          }),
        ]);

        this.canReverseStatus = reverseStatusPermission.data == 'Full';
        this.canSetExitStatus = setExitStatusPermission.data == 'Full';
      } catch (err) {
        console.error(err);
      }
    },
    onAdd() {
      this.formElements.forEach((e) => {
        e.Value = '';
      });
      this.isNewMemberForm = true;
      this.isEditMode = true;
      this.$refs.form.validate();
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      this.isNewMemberForm = false;
      if (this.selectedMemberId) this.getMemberData();
      else this.$router.push({ name: 'MemberSearch', path: '/' });
    },
    onSave() {
      const isFormValid = this.$refs.form.validate();
      if (isFormValid) this.saveData();
    },
    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteMember();
      } catch (err) {
        console.log();
      }
    },
    // click events
    onButtonClicked(value) {
      if (value == 'cancel') {
        // reload data
        this.isEditMode = false;
        this.isNewMemberForm = false;
        if (this.selectedMemberId) this.getMemberData();
        else this.$router.push({ name: 'MemberSearch', path: '/' });
      } else if (value == 'add') {
        // clear form
        this.formElements.forEach((e) => {
          e.Value = '';
        });
        this.isNewMemberForm = true;
        this.isEditMode = true;
      } else if (value == 'save') {
        const isFormValid = this.$refs.form.validate();
        if (isFormValid) this.saveData();
      } else if (value == 'edit') {
        this.isEditMode = true;
      } else if (value == 'delete') {
        this.deleteMember();
      }
    },
    calculateMaxFormWidth(maxColumnCount) {
      this.formMaxWidth = maxColumnCount * 400;
    },
    async getMemberData() {
      if (this.selectedMemberId) {
        try {
          this.getStatusHistory();
          let response = await this.$api.get('/member/getmember?id=' + this.selectedMemberId);

          if (!response.data) {
            const msg = 'Unable to get member data';
            this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
            throw new Error(msg);
          }

          var data = response.data;
          this.memberData = data;

          var status = this.statusList.find((s) => s.Id === data.CurrentStatus);
          if (status != null) {
            this.currentStatus = status.Text;
          } else {
            this.currentStatus = status.Id;
          }

          if (data) Utils.setDataToFormElements(data, this.formElements);

          this.getUserData();
        } catch (err) {
          console.error(err);
        }
      }
    },
    async getUserData() {
      if (this.selectedMemberId) {
        try {
          let response = await this.$api.get(
            '/member/getmemberuserdata?id=' + this.selectedMemberId
          );

          if (response.data) {
            var data = response.data;
            this.userData = data;

            if (data) Utils.setDataToFormElements(data, this.formElements);
          }
        } catch (err) {
          console.error(err);
        }
      }
    },

    async getStatusHistory() {
      try {
        let response = await this.$api.get(
          '/member/getstatuslist?membershipid=' + this.selectedMemberId
        );

        var data = response.data;
        if (data) {
          const found = this.formElements.find((element) => element.FieldType === 'StatusHistory');
          if (found) {
            found.LookupItems = data;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async saveData() {
      const memberData = this.createMemberData();
      if (memberData.MembershipId) this.updateMember(memberData);
      else this.addMember(memberData);
    },
    async updateMember(memberData) {
      try {
        const payload = {
          memberData: memberData,
          userData: memberData,
        };

        await this.$api.post('/member/UpdateMember', payload);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Member was updated',
        });
        this.getMemberData();
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async addMember(memberData) {
      try {
        const payload = {
          memberData: memberData,
          userData: memberData,
        };

        let response = await this.$api.post('/member/addmember', payload);

        memberData.MembershipId = response.data.Value;
        const message = { type: 'success', text: 'Save was successful' };
        const member = {
          MembershipId: memberData.MembershipId,
          Surname: memberData.Surname,
          Forename: memberData.Forename,
          EmployeeNo: memberData.EmployeeNo,
          Title: memberData.Title,
        };
        this.$store.commit('setSelectedMember', member);
        this.$store.commit('setNotificationMessage', message);
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },
    async deleteMember() {
      try {
        await this.$api.delete('/member/deletemember?member=' + this.selectedMemberId);

        const message = {
          type: 'success',
          text: 'Delete was successful',
        };
        this.$store.commit('setSelectedMember', null);
        this.$store.commit('setNotificationMessage', message);
        this.$router.push({ name: 'MemberSearch', path: '/' });
      } catch (err) {
        console.error(err);
      }
    },
    async ninoChange(event) {
      if (
        this.selectedMemberId === null &&
        event.target.value != '' &&
        this.stateNoCheck != event.target.value
      ) {
        try {
          this.stateNoCheck = event.target.value;
          let response = await this.$api.get(
            '/member/checkpersonexists?stateno=' + event.target.value
          );
          if (response.data) {
            await this.$refs.confirmationDialog.open(
              'Confirmation',
              'This NI Number already exists. Do you wish to load personal details ?'
            );
            this.copyPersonalData(response.data);
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    copyPersonalData(data) {
      this.formElements.forEach((f) => {
        if (f.DataTable === 'Personal') {
          var value = data[f.FieldName];
          f.Value = value;
        }
      });
    },
    async getMemberForm() {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=' +
            this.formName +
            '&planId=' +
            this.currentPlanId
        );

        if (response.data.length) {
          this.formElements = response.data.filter((f) => f.Visible == true);
        }
        if (this.selectedMemberId) this.getMemberData();
        setTimeout(() => {
          this.$refs.form.validate();
        }, 100);
        var sf = this.formElements.find((f) => f.FieldName === 'CurrentStatus');
        if (sf != null) {
          this.statusList = sf.LookupItems;
        }
        var nino = this.formElements.find((f) => f.FieldName === 'StateNo');
        if (nino) {
          nino.onChange = this.ninoChange;
        }
      } catch (err) {
        console.error(err);
      }
    },
    createMemberData() {
      const memberData = {};
      if (this.formElements) {
        this.formElements.forEach((x) => {
          if (x.FieldName && x.FieldType != 'Tab') memberData[x.FieldName] = x.Value;
        });
      }
      const membershipId = this.isNewMemberForm ? 0 : this.selectedMemberId;
      memberData['MembershipId'] = membershipId;
      memberData['PlanId'] = this.currentPlanId;

      return memberData;
    },
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    formName() {
      return this.$route.name;
    },
    selectedMemberId() {
      console.log('get : ' + this.$store.getters.selectedMemberId);
      return this.$store.getters.selectedMemberId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
  watch: {
    selectedMemberId: function () {
      this.getMemberData();
    },
    currentPlanId: function () {
      this.getStatusPermissions();
    },
  },
};
</script>

<style lang="scss">
.memberDetails {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
  .footerBtnContainer {
    .btnContainer {
      margin-left: 20px;
      margin-right: 20px;
      margin-bottom: 12px;
      margin-top: 12px;
      display: flex;
      width: 100%;
      text-align: right;
    }
  }
}
.v-footer {
  padding: 0px;
}
</style>
